import { scrubBreadcrumb, scrubEvent } from "@mesketch/domain/report";

// Hlášení chyb z prohlížeče do GlitchTipu (DEC-005, NFR-002): projekt mesketch-web, Sentry SDK 7,
// bez osobních údajů, každá událost projde čištěním (tokeny v adresách, tělo, hlavičky). SDK se
// načte až po startu aplikace jako samostatný blok (rozpočet NFR-003). DSN dodá jen build pro
// nasazení (VITE_SENTRY_DSN), bez něj se nic neposílá.

export function startErrorReporting(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (dsn === undefined || dsn === "") return;
  void import("@sentry/browser").then((Sentry) =>
    Sentry.init({
      dsn,
      environment: import.meta.env.VITE_APP_ENV ?? "dev",
      release: import.meta.env.VITE_GIT_COMMIT,
      sendDefaultPii: false,
      autoSessionTracking: false,
      maxBreadcrumbs: 30,
      beforeSend: (event) => scrubEvent(event),
      beforeBreadcrumb: (breadcrumb) => scrubBreadcrumb(breadcrumb),
    }),
  );
}
